import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Viewer } from 'components';
import { CleanIcon, DownloadExcelIcon, PaymentIcon, ListIcon, BankIcon, ViewIcon } from 'assets/icons';
import { PaymentService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: '',
	san: '',
	status: '',
	reference: '',
	country_id: ''
}

declare var window: any;

class Payments extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Usuario',
			'San',
			'País',
			'Fecha',
			'Monto',
			'Método de pago',
			'Cuota',
			'Fecha de corte',
			'Estatus',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Pagos de cuotas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await PaymentService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.payments.rows,
			last_page: res.payments.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	download = async () => {
		const res: any = await PaymentService.admin.download({
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	viewFile = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	closeFile = () => {
		this.setState({
			visible: false,
			item: null
		});
	}
	
	render() {
		const { visible } = this.state;
		const item: any = this.state.item;

		return (
			<div id="admin-payments">
				<Viewer
			      visible={ visible }
			      onClose={ () => this.closeFile() }
			      images={ [{ src: Constants.BASE_STORAGE + item?.file }] }
			    />

				<div className="row row-tabs">
					<div className="col-md-4">
						<Link to="/admin/payments">
							<div className="item-tab active">
								<img src={ PaymentIcon } />
								<p>Pagos de cuotas</p>
							</div>
						</Link>
					</div>
					<div className="col-md-4">
						<Link to="/admin/partial-payments">
							<div className="item-tab">
								<img src={ ListIcon } />
								<p>Pagos parciales</p>
							</div>
						</Link>
					</div>
					<div className="col-md-4">
						<Link to="/admin/bank-payments">
							<div className="item-tab">
								<img src={ BankIcon } />
								<p>Reporte Bancario</p>
							</div>
						</Link>
					</div>
				</div>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-11">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por correo"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md">
									<Input
										value={ this.state.form.san }
										name="san"
										placeholder="Buscar"
										label="Nº de SAN"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<Input
										value={ this.state.form.reference }
										name="reference"
										placeholder="Buscar"
										label="Referencia"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<Select
										placeholder="Seleccionar"
										label="País"
										name="country_id"
										color="white"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.country_id }
										options={ [
											{ value: Constants.COUNTRIES.VZLA.toString() , label: 'Venezuela' },
											{ value: Constants.COUNTRIES.COL.toString() , label: 'Colombia' }
										] } />
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Pagos Registrados" data={ this.state.data.length } header={ this.state.header } titleRight={
					<React.Fragment>
						{
							this.state.data.length > 0 && (
								<div className="container-add-table">
									<p>Descargar Excel</p>
									<button className="btn add-btn-table" onClick={ this.download }>
										<img src={ DownloadExcelIcon } />
									</button>
								</div>
							)
						}
					</React.Fragment>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td className="container-name">
									<p>{ (i.user?.name || '') + ' ' + (i.user?.lastname || '') }</p>
									<p className="bold">{ i.user?.email }</p>
									<p>{ ((i.user?.document_type?.name || '') + ((i.user?.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || i.user?.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + i.user?.document }</p>
									<p><span className="bold">Referencia:</span> { i.chinchin_id || i.reference || '-' }</p>
								</td>
								<td>{ i.san?.code }</td>
								<td>{ i?.san?.country?.name }</td>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ Globals.formatMiles(i.total,true,i.currency_symbol) }</td>
								<td>{ i.payment_method?.name }</td>
								<td>{ i.due_number }</td>
								<td>{ moment(i.expiration_date).isValid() ? moment(i.expiration_date).format('DD/MM/YYYY') : '-' }</td>
								<td>{ i.status_text }</td>
								<td>
									{
										i.file && (
											<Tooltip title="Ver">
												<a className="link-icon" href="#" onClick={ (e: any) => this.viewFile(e,i) }>
													<img src={ ViewIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Payments);